/**
 *
 * @ScriptName  : storage-manager.js
 * @Version     : 1.0.0
 * @Author      : masahiro.imanaka
 * @Description :
 *
 * ＜使い方＞
 *
 *
 */


(function( ){


	StorageManager = function(name, initObj, useSession){

		var storage = null ;
		if( useSession ){
			try{
				if(sessionStorage){
					storage = sessionStorage ;
				}
			}catch( err ) {}
		}else{
			try{
				if(localStorage){
					storage = localStorage ;
				}
			}catch( err ) {}
		}

		//

		var _this = this , i ;

		StorageManager[name] = _this ;
		_this.data = null ;

		//

		_this.save = function(){
			try{
				if(storage && storage.setItem){
					storage.setItem( name  , JSON.stringify( _this.data ) ) ;
				}
			}catch( err ) {}
		}

		//

		_this.log = function( ){
			console.log( _this.data ) ;
			console.log( JSON.stringify( _this.data ) ) ;
		}

		//

		_this.clear = function( ){
			try{
				if(storage && storage.removeItem){
					storage.removeItem( name ) ;
				}
			}catch(err) {}
		}

		if( /\?clear/.test( location.href ) ){
			_this.clear( ) ;
		}

		//

		try{
			if(storage && storage.setItem){
				_this.data = storage.getItem( name ) ;
			}
		}catch(err) {}

		if( _this.data ){
			_this.data = JSON.parse( _this.data ) ;
		}
		else{
			_this.data = initObj ;
		}
		_this.save() ;
	}


} )( ) ;
